import React from "react";
import { Container } from "react-bootstrap";
import "./Banner.css";

const Banner = () => {
  return (
    <section className="banner-image">
      <Container className="text-center">
        <h2 className="p-5">YOUR BEAUTIFUL SMILE</h2>
      </Container>
    </section>
  );
};

export default Banner;
